import { COUNTRY, COUNTRY_CONFIG_WITH_LANG, LANGUAGE } from "@type/index";

export const contactUsUrl: COUNTRY_CONFIG_WITH_LANG<string> = {
  [COUNTRY.AU]: {
    [LANGUAGE.EN]: "https://faq-au.uniqlo.com/contactus"
  },
  [COUNTRY.CA]: {
    [LANGUAGE.EN]: "https://faq-ca.uniqlo.com/uqcacontactus",
    [LANGUAGE.FR]: "https://faq-ca.uniqlo.com/uqcacontactusfr/?a=MDAwMDAxMDEw"
  },
  [COUNTRY.ID]: {
    [LANGUAGE.EN]: "https://faq-id.uniqlo.com/contactusen",
    [LANGUAGE.ID]: "https://faq-id.uniqlo.com/contactus/"
  },
  [COUNTRY.IN]: {
    [LANGUAGE.EN]: "https://faq-in.uniqlo.com/contactus/"
  },
  [COUNTRY.MY]: {
    [LANGUAGE.EN]: "https://faq-my.uniqlo.com/contactus"
  },
  [COUNTRY.PH]: {
    [LANGUAGE.EN]: "https://faq-ph.uniqlo.com/contactus"
  },
  [COUNTRY.SG]: {
    [LANGUAGE.EN]: "https://faq-sg.uniqlo.com/contactus/"
  },
  [COUNTRY.TH]: {
    [LANGUAGE.EN]: "https://faq-th.uniqlo.com/contactusen/",
    [LANGUAGE.TH]: "https://faq-th.uniqlo.com/contactus/"
  },
  [COUNTRY.VN]: {
    [LANGUAGE.EN]: "https://faq-vn.uniqlo.com/contactusen",
    [LANGUAGE.VI]: "https://faq-vn.uniqlo.com/contactus"
  }
};
